import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {SplitService} from "../../services/split-service.service";

export class BringozLabelsDisplayComponent implements IController {

  labels?: string[];
  maxItems?: any;

  public viewLabels: string[];
  public extraLabelsCount: number;
  public extraLabels: string[];
  public labelsMap: {} = {};

  constructor(private splitService: SplitService) {
  }

  $onInit() {
    const siteLabels = this.splitService.getSiteLabels();
    _.forEach(siteLabels, (l) => {
      this.labelsMap[l.name] = l;
    })
    this.viewLabels = [];
    this._initItems(this.labels);
  }

  $onChanges(changes) {
    if (changes.labels && !changes.labels.isFirstChange()) {
      this.viewLabels = [];
      this._initItems(this.labels);
    }
  };

  private _initItems(labels: string[]) {
    this.extraLabelsCount = undefined;

    if (_.get(labels, 'length')) {
      this.viewLabels = this.maxItems ? _.filter(labels, (item, index) => {
        return index < this.maxItems;
      }) : labels;

      if (labels.length > this.viewLabels.length) {
        this.extraLabelsCount = (labels.length - this.viewLabels.length);
        this.extraLabels = labels.slice(this.maxItems);
      }

    }
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozLabelsDisplay', {
    bindings: {
      labels: '<?',
      maxItems: '<?',
    },
    template: require('./bringoz-labels-display.html').default,
    controller: BringozLabelsDisplayComponent
  });
